import React from 'react';
import styles from './styles.module.css';

const Message = props => <div className={styles.content}>{props.children}</div>;

export default Message;
